import api from "../../../api/client";
import { Card, Row, Col, Button, Tag, Space, Dropdown, Typography } from "antd";
import {
  MailOutlined,
  PrinterOutlined,
  DollarOutlined,
  ClockCircleOutlined,
  MoreOutlined,
  BellOutlined,
  ShareAltOutlined,
  ArrowLeftOutlined,
} from "@ant-design/icons";
import config from "../../../config";

const { Title, Text } = Typography;

const InvoiceHeader = ({
  invoice,
  onSend,
  onRecordPayment,
  onReminder,
  onShare,
}) => {
  const getStatusColor = () => {
    if (invoice.paymentStatus === "fully_paid") return "green";
    if (invoice.paymentStatus === "partially_paid") return "orange";
    if (invoice.paymentStatus === "unpaid") return "red";
    return "default";
  };

  const token = localStorage.getItem("token");

  const handlePrint = async (type, action = "print") => {
    try {
      const response = await api.get(
        `/api/documents/${type}/${invoice.id}?action=${action}`,
        {
          responseType: "blob",
        },
      );

      const file = new Blob([response.data], {
        type: "application/pdf",
      });

      const fileURL = URL.createObjectURL(file);

      if (action === "print") {
        window.open(fileURL, "_blank");
      } else {
        const a = document.createElement("a");
        a.href = fileURL;
        a.download = `${type}-${invoice.id}.pdf`;
        a.click();
      }
    } catch (err) {
      console.error(err);
    }
  };

  const handleDownload = (type, action) => {
    window.open(
      `/api/documents/${type}/${invoice.id}/print?action=${action}`,
      "_blank",
    );
  };

  const moreMenu = {
    items: [
      {
        key: "delivery",
        label: "Print Delivery Note",
        onClick: () => handlePrint("delivery_note"),
      },
      // {
      //   key: "credit",
      //   label: "Print Credit Note",
      //   onClick: () => handlePrint("credit_note"),
      // },
      // {
      //   key: "debit",
      //   label: "Print Debit Note",
      //   onClick: () => handlePrint("debit_note"),
      // },
    ],
  };

  const handleBack = () => {
    window.history.back();
  };

  return (
    <Card>
      <Row justify="space-between" align="middle">
        {/* LEFT SIDE */}
        <Col>
          <Space>
            <Button icon={<ArrowLeftOutlined />} onClick={handleBack}>
              Back
            </Button>
            <Title level={4} style={{ margin: 0 }}>
              Invoice #{invoice.id}
            </Title>
            <Tag color={getStatusColor()} className="text-capitalize">
              {invoice.paymentStatus}
            </Tag>
          </Space>
        </Col>

        {/* RIGHT SIDE ACTIONS */}
        <Col>
          <Space>
            <Button icon={<MailOutlined />} onClick={onSend}>
              Send Email
            </Button>

            <Button
              icon={<PrinterOutlined />}
              onClick={() => handlePrint("invoice")}
            >
              Print PDF
            </Button>

            {/* <Button type="primary" icon={<DollarOutlined />}>
              Record Payment
            </Button> */}

            {/* <Button icon={<ClockCircleOutlined />}>Reminder</Button> */}
            <BellOutlined />
            <ShareAltOutlined />
            <Dropdown menu={moreMenu}>
              <Button icon={<MoreOutlined />} />
            </Dropdown>
          </Space>
        </Col>
      </Row>
    </Card>
  );
};

export default InvoiceHeader;
